
import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAd9tzgbhpXUBrQknT4-IbEGwLQ3jClTms",
  authDomain: "about-me-aa7fa.firebaseapp.com",
  projectId: "about-me-aa7fa",
  storageBucket: "about-me-aa7fa.appspot.com",
  messagingSenderId: "847516445938",
  appId: "1:847516445938:web:1ea773d9c93656ecad746b",
  measurementId: "G-SPH1LW8XN8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default getFirestore(app);